import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  minHeight: {
    minHeight: "200px",
  },
  progress: {
    height: "100%",
    width: "100%",
  },
}));
